<template>
  <div class="no-dialogs">
    <div class="title">You don't have any dialogues yet</div>
    <div class="desc">Once you create your dialogue, you can find it here</div>
    <router-link to="/create">
      <button @click="onClick">
        <font-awesome-icon :icon="['fas', 'plus']" class="icon" />
        Add first dialogue
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NoDialogs',
  methods: {
    onClick() {
      this.$emit('addDialog');
    }
  }
}
</script>

<style lang="scss" scoped>
.no-dialogs {
  width: 55rem;
  height: 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;

  @media (max-width: 900px) {
    width: 90vw;
  }
  @media (max-width: 600px) {
    margin-top: 3rem;
  }
  @media (max-width: 480px) {
    .title {
      font-size: 1.3rem !important;
    }
    .desc {
      font-size: 1.1rem !important;
    }
  }
  @media (max-width: 400px) {
    .title {
      text-align: center;
      font-size: 1.1rem !important;
    }
    .desc {
      text-align: center;
      font-size: 0.9rem !important;
      padding-left: 1rem;
      padding-right: 1rem;
    }
    button {
      padding-left: 1rem !important;
      padding-right: 1rem !important;
      font-size: 1rem !important;
    }
  }

  .title {
    font-size: 1.5rem;
    font-weight: bold;
    word-spacing: 0.2rem;
    color: #11b6a5;
  }

  .desc {
    margin-top: 1rem;
    font-size: 1.3rem;
    font-weight: bold;
    word-spacing: 0.2rem;
    opacity: 0.3;
  }

  button {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    margin-top: 2.5rem;
    background-color: #11b6a5;
    color: white;
    border: none;
    outline: none;
    font-size: 1.2rem;
    border-radius: 3rem;
    transition: all 0.2s;

    .icon {
      margin-right: 0.3rem;
      font-size: 1rem;
    }

    &:hover {
      cursor: pointer;
      background-color: #12a899;
    }
  }
}
</style>